const COLORS = {
  wow: '#4D11F6',
  intro: '#7A81E9',
  walk: '#34D188',
  cta: '#7A81E9',
  final_frame: '#1A2238',
};

const LABELS = {
  wow: 'WOW',
  intro: 'Intro',
  walk: 'Walk',
  cta: 'CTA',
  final_frame: 'Close',
};

function formatTime(s) {
  const mins = Math.floor(s / 60);
  const secs = Math.round(s % 60);
  return mins > 0 ? `${mins}:${String(secs).padStart(2, '0')}` : `${secs}s`;
}

export function TimelinePreview({ debug }) {
  if (!debug) return null;

  // Support both new (segments array) and legacy (computed) formats
  let segments;
  if (Array.isArray(debug.segments)) {
    // Merge adjacent same-type segments for display
    segments = [];
    let current = null;
    for (const s of debug.segments) {
      if (current && current.type === s.type) {
        current.duration += s.duration;
        current.count++;
      } else {
        if (current) segments.push(current);
        current = { ...s, count: 1 };
      }
    }
    if (current) segments.push(current);
  } else {
    // Legacy format
    segments = [];
    if (debug.wow_shots > 0) segments.push({ type: 'wow', duration: 5, count: debug.wow_shots });
    if (debug.has_intro) segments.push({ type: 'intro', duration: 8, count: 1 });
    const wDur = (debug.total_duration || 0) - 5 * (debug.wow_shots > 0 ? 1 : 0) - 8 * (debug.has_intro ? 1 : 0) - 8 * (debug.has_cta ? 1 : 0) - 5 * (debug.has_closing_frame ? 1 : 0);
    if (debug.walkthrough_clips > 0) segments.push({ type: 'walk', duration: Math.max(wDur, 1), count: debug.walkthrough_clips });
    if (debug.has_cta) segments.push({ type: 'cta', duration: 8, count: 1 });
    if (debug.has_closing_frame) segments.push({ type: 'final_frame', duration: 2, count: 1 });
  }

  const totalDur = debug.total_duration || segments.reduce((s, seg) => s + seg.duration, 0);
  if (totalDur <= 0 || segments.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="timeline-preview">
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold text-[#020B23]" style={{ fontFamily: 'Sora, sans-serif' }}>
          Timeline Preview
        </p>
        <span className="text-[10px] text-[#94969C]">{formatTime(totalDur)} total</span>
      </div>

      {/* Bar */}
      <div className="flex h-8 rounded-lg overflow-hidden border border-[#E2E4E7]">
        {segments.map((seg, i) => {
          const pct = Math.max(2, (seg.duration / totalDur) * 100);
          return (
            <div
              key={i}
              style={{ width: `${pct}%`, backgroundColor: COLORS[seg.type] || '#94969C' }}
              className="flex items-center justify-center text-[9px] text-white font-medium truncate px-1 transition-all"
              title={`${LABELS[seg.type] || seg.type} (${formatTime(seg.duration)})`}
            >
              {pct > 8 && (LABELS[seg.type] || seg.type)}
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        {segments.map((seg, i) => (
          <div key={i} className="flex items-center gap-1.5">
            <div className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: COLORS[seg.type] || '#94969C' }} />
            <span className="text-[10px] text-[#676970]">
              {LABELS[seg.type] || seg.type}
              {seg.count > 1 ? ` x${seg.count}` : ''}
              {' '}({formatTime(seg.duration)})
            </span>
          </div>
        ))}
        {debug.alignment_used && (
          <span className="text-[10px] text-emerald-600 font-medium" data-testid="alignment-active-badge">Voiceover-aligned</span>
        )}
      </div>
    </div>
  );
}
